import { render, staticRenderFns } from "./TheCompareModal.vue?vue&type=template&id=5f4ba45e&"
import script from "./TheCompareModal.vue?vue&type=script&lang=js&"
export * from "./TheCompareModal.vue?vue&type=script&lang=js&"
import style0 from "./TheCompareModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports